<template>
  <footer class="py-4 bg-black">
    <div class="container mx-auto px-4">
      <p class="text-sm text-center text-white">© CÓRDOBA OPEN. TODOS LOS DERECHOS RESERVADOS.</p>
    </div>
  </footer>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'FooterSection',
   methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>